import {
 API_HOST_REFDATA,
 API_HOST_USERS,
 API_ROOT_NOTIFICATIONS,
} from '../config';
import { NotificationsService } from './business/NotificationsService';
import { LocalLookupService } from '@ofqual/portal-core/core/dataAccess';
import notificationTypes from './json/notificationTypes.json';
import directorateLookups from './json/directorateLookups.json';
import matterTypeLookups from './json/matterTypeLookups.json';
import { UserService } from './business/UserService';
import { refDataEndpoints, RefDataService } from './business/RefDataService';

export const notificationsService = new NotificationsService(
 API_ROOT_NOTIFICATIONS,
);

export const notificationTypesService = new LocalLookupService(
 notificationTypes,
);
export const directorateLookupService = new LocalLookupService(
 directorateLookups,
);
export const matterTypeLookupService = new LocalLookupService(
 matterTypeLookups,
);
export const usersService = new UserService(API_HOST_USERS);

export const lcmPolicyProjectCategoryService = new RefDataService(
 API_HOST_REFDATA,
 refDataEndpoints.lcmPolicyProjectCategory,
);

export const lcmPolicyProjectSubCategoryService = new RefDataService(
 API_HOST_REFDATA,
 refDataEndpoints.lcmPolicySubCategory,
);
